import uuid from 'uuid/v4';
import qs from 'query-string';

import { DesignShowcase_designShowcase_exhibits } from '@graphql/designShowcaseTypes';
import { CreateEventQueryStringComponent } from '../../DesignDemo/types';
import { Layout } from '@graphql/types';

const fontMapping = {
  'Lush Script': 'Allura',
  'Penna Connected': 'Pinyon Script',
  Komu: 'Fjalla One',
  'Proxima Nova': 'Roboto'
};

/**
 * When a guest wants to start with a specific design, this function will generate
 * a query string that will set the foundation of their event design.
 *
 * @param targetExhibit The exhibit that will the base of design for creating an Event.
 */

export const generateCreateEventQueryString = (
  targetExhibit: DesignShowcase_designShowcase_exhibits
): string | null => {
  // const queryStrings: { key: CreateEventFromSpec; value: string }[] = [];
  const components: CreateEventQueryStringComponent = {};
  if (targetExhibit.spec) {
    // Layout
    if (targetExhibit.spec.websiteLayout) {
      components.template = targetExhibit.spec.websiteLayout.template as Layout;
    }

    // Theme
    if (targetExhibit.spec.style) {
      components.theme = targetExhibit.spec.style.id;
    }

    // Font
    if (targetExhibit.spec.fontName) {
      const exhibitFont = targetExhibit.spec.fontName;

      if (fontMapping[exhibitFont]) {
        components.font = fontMapping[exhibitFont];
      } else {
        components.font = targetExhibit.spec.fontName;
      }
    }

    if (targetExhibit.spec.usesWeddingColor !== null) {
      components.usesWeddingColor = targetExhibit.spec.usesWeddingColor;
    }

    // Palette
    if (targetExhibit.spec.palette) {
      const {
        paletteId,
        paletteName,
        accentColor: { floatArray: accentColor },
        baseColor: { floatArray: baseColor },
        accentText: { floatArray: accentText },
        baseText: { floatArray: baseText },
        accentLightText,
        baseLightText
      } = targetExhibit.spec.palette;
      components.palette = JSON.stringify({
        paletteId: paletteId || uuid(),
        paletteName: paletteName || 'My Custom Color',
        accentColor,
        baseColor,
        accentText,
        baseText,
        accentLightText,
        baseLightText
      });
    }

    if (targetExhibit.spec.primaryPhotoHorizontal && targetExhibit.spec.primaryPhotoHorizontal.assetId) {
      components.assetId = targetExhibit.spec.primaryPhotoHorizontal.assetId;
    }

    if (targetExhibit.spec.owner) {
      components.owner = targetExhibit.spec.owner.split(' ')[0];
    }

    if (targetExhibit.spec.fiancee) {
      components.fiancee = targetExhibit.spec.fiancee.split(' ')[0];
    }

    if (targetExhibit.spec.message) {
      components.greeting = targetExhibit.spec.message;
    }

    if (Object.keys(components).length) {
      return qs.stringify(components, { sort: false } as any);
    }
  }
  return null;
};
